export default __webpack_public_path__ + "b2a55c6b4ce22fac5f31f612c61bcb1d.jpg";